import { getRouteUrl } from 'config/routes';

export const useRedirectToTargetAudienceCreation = () => {
  const targetAudiencePath = getRouteUrl('brandHubV2TargetAudience');

  return () => {
    window.open(window.origin + targetAudiencePath, '_blank');
  };
};
